import { FlowType } from '@jerry-serverless/types';

import type { AppData } from '../../../types/app_data';
import type { Step } from '../../types/step';
import { StepCategory } from '../../../types/app_data';
import { growthBookInstance } from '../../../utils/analytics/growthbook';
import {
  ABTestCarRecallNamePageMutipleSubtitle,
  ABTestCarValueCombineNameAndPhone,
} from '../../../utils/enabled_features/ab_tests';

export const NameStep: Step = {
  id: 'name',
  pathname: '/name',
  canShow: (appData: AppData) => {
    // send tracking event early
    if (appData.flowType === FlowType.CarRecall) {
      // here we call getFeatureValue to send track event early
      growthBookInstance?.getFeatureValue(ABTestCarRecallNamePageMutipleSubtitle.storageKey, 0);
    } else if (appData.flowType === FlowType.CarValue) {
      const abtestVariation = growthBookInstance?.getFeatureValue(ABTestCarValueCombineNameAndPhone.storageKey, 0) ?? 0;
      if (abtestVariation > 0) return false;
    }

    if (appData.isFromMAL) return false;
    if (appData.isOnboardingLite) return false;

    // If we're asking name on the partner landing page, we shouldn't show separate name step.
    return !appData.featureData?.askPhoneNamePrefilled;
  },
  hasData: () => true,
  hasOwnData: (appData: AppData) => !!appData.name,
  category: () => StepCategory.GarageOnlyAccount,
};
